import { DiscussionType, Message } from "@cnx/common";
import { Box } from "@mantine/core";
import ChatDateDivider from "./ChatDateDivider";
import ChatMessageItem from "./ChatMessageItem";
import UnreadMessageIndicator from "./UnreadMessageIndicator";

type ChatMessageGroupProps = {
  dateKey: string;
  items: Message[];
  discussionType?: DiscussionType;
  firstUnreadMessageId?: string | null;
  unReadCount: number;
  selectedMessageIds?: string[];
  onSelect?: (message: Message) => void;
};

const ChatMessageGroup = ({
  dateKey,
  items,
  discussionType,
  firstUnreadMessageId,
  unReadCount,
  selectedMessageIds,
  onSelect,
}: ChatMessageGroupProps) => {
  return (
    <Box>
      <ChatDateDivider dateKey={dateKey} />
      {items.map((item, index) => {
        const firstUnreadMessage = item.id === firstUnreadMessageId;

        return (
          <Box key={index}>
            <Box>
              {firstUnreadMessage && (
                <UnreadMessageIndicator count={unReadCount} />
              )}
            </Box>
            <ChatMessageItem
              item={item}
              discussionType={discussionType}
              isSelected={!!item.id && (selectedMessageIds?.includes(item.id) ?? false)}
              onSelect={onSelect}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ChatMessageGroup;
